<template>
	<div>
		<div class="withtitle">
			Amount to be Withdrawn
		</div>
		<div style="padding: 10px 10px;">
			<span class="must">*</span>
			Below is the amount of money available to withdraw
		</div>
		<div class="below">
			<div class="Date">Date</div>
			<div>Total Amount(Unit:USD)</div>
			<div class="line"></div>
			<div class="Date">{{applytime}}</div>
			<div>{{adjust(totalIncome,2)}}</div>
			<div class="line"></div>
		</div>
		<!-- <div class="withtitle">
			Net Total
		</div>
		<input class="number" v-model="number" :style="showstatus?'margin-bottom:0px':''"/>
		<p v-show="showstatus" class="tips">提现的金额不能大于总金额</p> -->
		<div class="withtitle">
			receiving methods
		</div>
		<div>
			<el-tabs v-model="activeName" @tab-click="handleClick" class="diy-tab">
				<el-tab-pane :label="item.label" :key="item.label" :name="item.label" v-for="item in tablist">
					<div v-show="activeName=='For PayPal'">
						<div style="padding: 10px 10px;">
							<span class="must">*</span>
							Email address Linked to the account
						</div>
						<el-input v-model="form.emailAddress" placeholder="" style="width: 60%;" disabled></el-input>
						<div style="padding: 10px 10px;">
							<span class="must">*</span>
							Receiver's Name
						</div>
						<el-input v-model="form.recevierName" placeholder="" style="width: 60%;" disabled></el-input>
						<div style="padding: 10px 10px;">
							<span class="must">*</span>
							Country/Region
						</div>
						<el-input v-model="form.region" placeholder="Country/Region" style="width: 60%;" disabled></el-input>
						<div style="margin: 20px 20px;">
							<el-button type="primary" @click="sure()"> Confirm</el-button>
						    <el-button @click="cancle()">Cancel</el-button>
						</div>
						<div style="padding: 10px 10px;">
							<span class="must" style="color: black;font-weight: 600px;">*</span>
							the commission fee for receiving your payment is 2 USD/payment regardless of the country or regin rlease concat the payoneer team for more information
						</div>
					</div>
					<div v-show="activeName=='For Bank'">
						<div style="color: cornflowerblue;font-weight: 700;">
							(For bank transfers,GW Reader users Maybank,and the minimum commission is around 31.77 USD.The actual exchange rate will take precedence.)
						</div>
						<div style="padding: 10px 10px;">
							<span class="must">*</span>
							Receiver's Name
						</div>
						<el-input v-model="formbank.recevierName" placeholder="" style="width: 60%;" disabled></el-input>
						<div style="padding: 10px 10px;">
							<span class="must">*</span>
							ID/PASSPORT/Biz Registration No.
						</div>
						<el-input v-model="formbank.passport" placeholder="" style="width: 60%;" disabled></el-input>
						<div style="padding: 10px 10px;">
							<span class="must">*</span>
							Full Address
						</div>
						<el-input v-model="formbank.Address" placeholder="street twon/city,state,zip code,country" style="width: 60%;" disabled></el-input>
						<div style="margin: 20px 20px;">
							<el-button type="primary" @click="sure()">Confirm</el-button>
						    <el-button @click="cancle()">Cancel</el-button>
						</div>
					</div>
					<!-- <Incomehistory v-show="item.label=='Income history'"></Incomehistory>
					<CoinsReport v-show="item.label=='Daily Coins Report'"></CoinsReport> -->
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import { GetAuthorBankList,addAuthorCashOutDetail} from '../common/api/workincome.js'
	export default {
		props:{
			totalIncome:Number
		},
	    data() {
	      return {
			activeName:"For PayPal",
			tablist:[
				{label:"For PayPal",value:"For PayPal"},
				{label:"For Bank",value:"For Bank"}
			],
			formbank:{
				recevierName:"",
				passport:"",
				Address:""
			},
			form:{
				emailAddress:"",
				recevierName:"",
				region:""
			},
			applytime:""
	      };
	    },
		created() {
			this.GetList()
			this.applytime = this.formatDate(new Date())
			//替换指定位置的字符
			const replaceStr = (str, index, char) => {
			 return str.substring(0, index) + char + str.substring(index + 2);
			}
			let aa = this.datescreen(this.applytime.slice(0,2))
			this.applytime = replaceStr(this.applytime.toString(),0,aa)
		},
	    methods: {
			GetList(){
			  let data = {
			    data:{
			      page:1,
			      limit:10,
			      authorId:this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
				  // authorId:0,
			      penName:"",
			      fullName:"",
			      regEmail:"",
			    }
			  }
			  GetAuthorBankList(data).then((response) => {
			         this.tableData = response.data
			         this.total = response.total
			         for(let i in response.data){
			           this.tableData[i].bankType = this.tableData[i].bankType==1?'paypal':'银行卡'
					   if(this.tableData[i].bankType == '银行卡'){
						   this.formbank = this.tableData[i]
						   this.formbank.Address = this.tableData[i].houseAddress + '/' + this.tableData[i].city + ',' + this.tableData[i].state + ','
						    + this.tableData[i].zipCode + ',' + this.tableData[i].region
					   } else {
						   this.form = this.tableData[i]
					   }
			         }
					 
			  })
			},
			handleClick(){
				
			},
			sure(){
				if(this.totalIncome < 50){
					this.$message({
						message:"The withdrawal amount cannot be less than 50"
					})
					return
				}
				if(this.formbank.recevierName == ''&& this.activeName=='For Bank'){
					this.$message({
						message:"please fill in your payment details"
					})
					return 
				}
				if(this.activeName=='For PayPal' && this.form.emailAddress == ''){
					this.$message({
						message:"please fill in your payment details"
					})
					return 
				}
				let data = {
					data:{
						userId: this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
						userName:this.$store.state.userInfo.pseudonym,
						paypalRecvierName:this.form.recevierName,
						paypalEmailAddress:this.form.emailAddress,
						paypalRegion:this.form.region,
						idNumber: this.formbank.id,
						bankHouseAddress: this.formbank.recevierName,
						bankContactNumber: this.formbank.contactNumber,
						bankBankAccountNo: this.formbank.bankAccountNo,
						bankBankFullName: this.formbank.bankFullName,
						bankSwiftCode: this.formbank.swiftCode,
						bankCode: this.formbank.bankCode,
						bankBranchLocation: this.formbank.branchLocation,
						// bankEmailAddress: this.formbank.emailAddress,
						bankCity: this.formbank.city,
						bankState: this.formbank.state,
						bankRegion: this.formbank.region,
						bankZipCode:this.formbank.zipCode,
						bankCitizenship: this.formbank.citizenship,
						bankContactEmail:this.formbank.contactEmail,
						bankRecevierName:this.formbank.recevierName,
						passPort:this.formbank.passport,
						amount:this.totalIncome,
						status:3,
						bankType:this.activeName=='For PayPal'?1:2
					}
				}
				
				addAuthorCashOutDetail(data).then((res)=>{
					if(res.code == 1){
						this.$message({
							message:res.msg,
							type:"error"
						})
					} else { 
						this.$message({
							message:"Request Confirmed!",
							type:"success"
						})
					}
					this.$emit('cancella',false)
				})
			},
			cancle(){
			  this.$emit('cancella',false)
			},
			//四舍五入
			adjust(numberRound,roundDigit){
			  if (numberRound>=0){
			  var tempNumber = parseInt((numberRound * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
			  tempNumber += ''
			  if (!/\./.test(tempNumber)) {
			      tempNumber += '.00'
			  }
			  var arrayNum = tempNumber.split('.')
			  if (arrayNum[1].length < 2) {
			     tempNumber += '0'
			  }
			  return tempNumber;
			  } else{
			  var numberRound1=-numberRound;
			  var tempNumber = parseInt((numberRound1 * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
			  return -tempNumber;
			
			  }
			},
			datescreen(name){
				switch(name){
					case '01':
						return 'Jan'
						break;
					case '02':
						return 'Feb'
						break;
					case '03':
						return 'Mar'
						break;
					case '04':
						return 'Apr'
						break;
					case '05':
						return 'May'
						break;
					case '06':
						return 'Jun'
						break;
					case '07':
						return 'Jul'
						break;
					case '08':
						return 'Aug'
						break;
					case '09':
						return 'Sep'
						break;
					case '10':
						return 'Oct'
						break;
					case '11':
						return 'Nov'
						break;
					case '12':
						return 'Dec'
						break;
				}
			
			},
			//修改时间样式
			formatDate(Time) { //获得UTC的时间
				const moment = require('moment-timezone');
				if (Time == null) {
					return null
				}
				var timezone = "Asia/Shanghai";
				const clean = moment(Time).format('MM-DD-YYYY'); // 清除 timezone 信息
				const Shanghailocal = moment.tz(clean, timezone);
				return Shanghailocal.tz('UTC').format('MM-DD-YYYY')
			},
	    }
	  };
</script>

<style >
	.withtitle{
		width: 100%;
		background-color: #e8f0fd;
		padding: 7px 5px 7px 10px;
		border-radius: 5px;
	}
	.must{
		color:red;
		font-size:20px;
		position: relative;
		top: 5px;
	}
	.below{
		.Date{
			float: left;
			margin: 0px 100px 10px 30px;
		}
	}
	.number{
		margin: 10px 10px;
		height: 25px;
	}
	.tips{
		margin: 0px 15px;
		margin-bottom: 10px;;
		color: red;
		font-size: 10px;
	}
	.line{
		border:1px solid #CCC;
		margin: 10px 0px 10px 0px;
	}
</style>